import { Route, Redirect } from 'react-router-dom';
import { useHistory } from 'react-router';

const PrivateRoute = ({ children, ...rest }) => {
  const router = useHistory();

  rest.path?.forEach((r) => {
    if (r.replace(router.location.pathname, '') === '/*') {
      router.push(r.replace('/*', '/home'));
    }
  });

  const auth = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    // const refreshToken = JSON.parse(localStorage.getItem('refreshToken'));

    if (user) {
      return true;
    } else {
      return false;
    }
  };
  const userAuth = auth();

  return (
    <Route
      {...rest}
      render={() => {
        return userAuth ? children : <Redirect to='/login' />;
      }}
    />
  );
};

export default PrivateRoute;
